import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { PassageModel, PassageRequest } from '@generativ/much-smarter-models';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ErrorHandlerService } from '../../core/services/error-handler.service';

@Injectable({ providedIn: 'root' })
export class PassageService {

  passage: PassageModel;
  passages: PassageModel[] = [];

  private passagesURL = environment.msApiUrl + 'passages/';


  constructor(private http: HttpClient,
              private errorHandlerService: ErrorHandlerService) {
  }

  createPassage(passage: PassageRequest.Create): Observable<PassageModel> {
    return this.http.post<PassageModel>(this.passagesURL, passage).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  updatePassage(id: number, passage: PassageRequest.Update): Observable<PassageModel> {
    return this.http.patch<PassageModel>(this.passagesURL + id, passage).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getPassage(id: number): Observable<PassageModel> {
    return this.http.get<PassageModel>(this.passagesURL + id).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getPassages(): Observable<PassageModel[]> {
    return this.http.get<PassageModel[]>(this.passagesURL).pipe(
      catchError(this.errorHandlerService.handleError));
  }



}
